// Custom lazy load
function aboutPage() {

    if ( !$('div.about').length ) {
        return;
    }

    $('.about-nav a').anchorAnimate();
    $('section.stats h3').one('inview', function(event, isInView) {
        $('div.about section.stats p.stat strong').each(function(index){
            var el = $(this);
            el.parent().fadeTo(300, 1);
            el.countTo({
                from: 0,
                to:  el.data('count'),
                speed: 2000,//(1000 * (index + 1)) + 500,
                refreshInterval: 30,
                formatter: function (value, options) {
                    value = value.toFixed(options.decimals);
                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    return value;
                }
            });
        });
    });

    $('section.stats').one('inview', function(event, isInView) {

        $('section.stats p.stat').fadeTo(10,0);

    });

    var swiper = new Swiper('section.testimonials .swiper-container', {
        grabCursor: true,
        centeredSlides: true,
        scrollbarHide: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 1,
        grabCursor: true,
        autoplayDisableOnInteraction: true,
        mousewheelControl: false,
        mousewheelReleaseOnEdges: true,
        mousewheelForceToAxis: false,
        mousewheelSensitivity: 1,
        spaceBetween: 50,
        autoheight: true,
        autoplay: {
            delay: 8500
        },
        pagination: {
            el: 'section.testimonials .swiper-pagination',
        },
        navigation: {
            nextEl: 'section.testimonials .next',
            prevEl: 'section.testimonials .prev',
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

    var swiper = new Swiper('section.moments .swiper-container', {
        grabCursor: true,
        centeredSlides: true,
        navigation: {
            nextEl: 'section.moments .next',
            prevEl: 'section.moments .prev',
        },
        pagination: '#moments .sg-pager',
        paginationType: 'progress',
        scrollbarHide: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 'auto',
        grabCursor: true,
        autoplayDisableOnInteraction: true,
        paginationClickable: true,
        mousewheelControl: false,
        mousewheelReleaseOnEdges: true,
        mousewheelForceToAxis: false,
        mousewheelSensitivity: 1,
        spaceBetween: 50,
        autoplay: false,keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

    //autoNav();

}


/*
function autoNav() {

    var inview = $('section:in-viewport:first').attr('id');

    $('#sidenav a.active').removeClass('active');

    var link = $('#sidenav a[href="#' + inview + '"]');
    var text = $('#sidenav a[href="#' + inview + '"]').text();

    link.addClass('active');

}
*/
